import Layout from "../../shared/Layout/Layout";
import Hero from "./Components/Hero";
import Impact from "./Components/Impact";
import MembersPertners from "./Components/MembersPertners";
import Publications from "./Components/Publications";
import WhatWeDo from "./Components/WhatWeDo";
import WhoWeAre from "./Components/WhoWeAre";

import LatestNews from "./Components/LatestNews";
import Message from "./Components/Message";
import PromoBanner from "./Components/PromoBanner";

export default function Home() {
  return (
    <Layout>
      <PromoBanner />
      <Hero />
      <Message />
      <WhoWeAre />
      <WhatWeDo />
      <LatestNews />
      <Impact />
      <MembersPertners />
      <Publications />
    </Layout>
  );
}
